import { mapGetters } from 'vuex'

import { components } from '@/utils'

export default {
  name: 'GlobalSnackbar',

  computed: {
    ...mapGetters({ snackbars: 'notifications/snackbars' })
  },

  render(h) {
    return h(components.snackbar, { props: { items: this.snackbars } })
  }
}
